// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2tL0t","clinicsSelect":"TableHeading_clinicsSelect__-AGhQ"};